import { showCookiesPopup } from '@icontainers/design-system/dist/utils'
import { setGdprCookie } from '@src/Infrastructure/Cookies'

export const onClientEntry = (): void => {
    if (!showCookiesPopup()) {
        setGdprCookie({ necessary: true, marketing: true, performance: true })
    }
}
